export default [
  {
    path: '/tools/removebg',
    name: 'toolsRemovebg',
    component: () => import('@/views/tools/removeBg/removeBg.vue'),
    meta: { title: '智能抠图', requireAuth: true }
  },
  {
    path: '/tools/removeBg/result',
    name: 'toolsRemoveBgResult',
    component: () => import('@/views/tools/removeBg/result.vue'),
    meta: { title: '智能抠图结果', requireAuth: true }
  },
  {
    path: '/tools/sd',
    name: 'sd',
    component: () => import('@/views/tools/sd.vue'),
    meta: { title: '视频片段', requireAuth: true }
  },
  {
    path: '/tools/qa',
    name: 'qa',
    component: () => import('@/views/tools/qa.vue'),
    meta: { title: '问答视频', requireAuth: true }
  }
]
